import React, {useEffect, useState } from 'react';

import '../assets/styles/style.css';
import ReactPlayer from "react-player";

const HomeTop: React.FC<{ title?: any, subtitle?: any, buttonText?: any }> = ({title, subtitle, buttonText}) => {
  const [canAutoplay, setCanAutoplay] = useState(false);
  const [isWeChat, setIsWeChat] = useState(false);

  useEffect(() => {
    // Detect WeChat browser
    const isWeChatBrowser = /MicroMessenger/i.test(navigator.userAgent);
    setIsWeChat(isWeChatBrowser);

    // WeChat requires a user gesture to enable video playback
    const handleInteraction = () => {
      setCanAutoplay(true);
      document.removeEventListener('click', handleInteraction);
      document.removeEventListener('touchstart', handleInteraction);
    };

    if (isWeChatBrowser) {
      document.addEventListener('click', handleInteraction);
      document.addEventListener('touchstart', handleInteraction);
    } else {
      setCanAutoplay(true);
    }

    return () => {
      document.removeEventListener('click', handleInteraction);
      document.removeEventListener('touchstart', handleInteraction);
    };
  }, []);

  return (
    <section className="hero-banner relative h-auto">
      {/* WeChat requires a placeholder that users must click */}
      {isWeChat && !canAutoplay ? (
        <div
          className="w-full h-[56.25vw] bg-black flex items-center justify-center cursor-pointer"
          onClick={() => setCanAutoplay(true)}
        >
          <div className="text-white text-center p-4">
            <div className="text-4xl mb-3">▶</div>
            <p className="text-xl">点击播放视频</p>
          </div>
        </div>
      ) : (
        <ReactPlayer
          playing={canAutoplay}
          muted={true}
          controls={true}
          loop={true}
          width="100%"
          height="56.25vw"
          url="https://youtu.be/LUlJELctuME"
          playsinline
          config={{
            youtube: {
              playerVars: {
                autoplay: canAutoplay ? 1 : 0,
                modestbranding: 1,
                rel: 0,
                playsinline: 1
              }
            }
          }}
        />
      )}
    </section>
  );
}

export default HomeTop;